import { Module } from 'vuex'
import config from 'config'
import { initializeObject } from '@/helpers/utils'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'
import { ContentState } from './types'
import { RootState } from '../types'
import countries from './Countries'

export const initState: ContentState = {
  idCounter: 0,
  selectedLanguage: '',
  languages: [],
  contents: {},
  errors: initializeObject(Object.keys(config.content.legals), false),
  loaded: false,
  country: null,
  forcedCountry: null,
  countries: countries,
  needCountrySelection: false,
  iframe: false,
  hideGsc: false,
  consent: []
}

const namespaced = true

export const CONTENT: Module<ContentState, RootState> = {
  namespaced,
  actions,
  mutations,
  getters,
  state: initState
}
